"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToCallbacks = void 0;
const utils_1 = require("../../utils");
const operation_1 = require("../operation");
const translateToCallbacks = function (callbacks) {
    const callbackEntries = (0, utils_1.entries)(callbacks);
    if (!callbackEntries.length)
        return;
    return callbackEntries.reduce((results, [callbackName, path2Methods]) => {
        for (const [path, method2Op] of (0, utils_1.entries)(path2Methods)) {
            for (const [method, op] of (0, utils_1.entries)(method2Op)) {
                const document = {
                    openapi: '3',
                    info: { title: '', version: '1' },
                    paths: { [path]: { [method]: op } },
                };
                results.push({
                    ...(0, operation_1.transformOas3Operation)({
                        document,
                        method,
                        path,
                    }),
                    callbackName,
                });
            }
        }
        return results;
    }, []);
};
exports.translateToCallbacks = translateToCallbacks;
//# sourceMappingURL=callbacks.js.map